export default {"src":"/_next/static/media/delete-disabled.96da1825.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};